<div class="flex-direction-column page"
     [style.height]="isHml ? 'calc(100vh - 77px)' : 'calc(100vh - 61px)'">
  <div class="flex-direction-row justify-between align-center" style="padding: 10px 0 10px 0;">
    <div class="flex-direction-row align-center gap-10">
      <app-button-padrao iconSrc="icones/filtros" iconSrcExtensao=".svg"
        width="30px" height="30px" backgroundColor="transparent"
        widthIcon="22px" heightIcon="22px"
        matTooltip="Filtrar"
        (buttonClick)="abrirModalFiltro()">
      </app-button-padrao>
      <app-button-padrao iconSrc="icones/limpar" iconSrcExtensao=".svg"
        width="30px" height="30px" backgroundColor="transparent"
        widthIcon="22px" heightIcon="22px"
        matTooltip="Limpar filtros"
        (buttonClick)="iniciarFiltragemTemplates()">
      </app-button-padrao>
      <app-form-field
        style="margin-right: 1%"
        placeholder="Pesquisar"
        iconPrefix="search"
        borderColor="var(--primary)"
        iconColor="var(--primary)"
        backgroundColor="transparent"
        widthFormField="325px"
        heightFormField="35px"
        classe="pesquisar"
        [value]="nomeFiltro"
        (changeValue)="filtrarTemplates($event)">
      </app-form-field>
    </div>
  </div>

  @if (templates.length > 0 && !templatesCarregando) {
    <mat-table [dataSource]="templateDataSource" style="width: 98%; overflow: auto;">
      <ng-container matColumnDef="acao">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <div class="flex-direction-row gap-5 center-center">
            @if (!elemento?.enviadoMeta && !(ehTemplateSms(elemento) && elemento.utilizado)) {
              <app-button-padrao iconSrc="icones/edit" iconSrcExtensao=".svg" width="20px" height="20px" fontSize="20px"
                backgroundColor="transparent" widthIcon="20px" heightIcon="20px"
                (buttonClick)="abrirModal(false, elemento)"></app-button-padrao>
            } @else if (elemento.ativo) {
              <app-button-padrao iconSrc="icones/delete-forever" iconSrcExtensao=".svg" width="20px" height="20px" fontSize="20px"
                backgroundColor="transparent" widthIcon="20px" heightIcon="20px"
                (buttonClick)="inativarTemplate(elemento)"></app-button-padrao>
            }
            <app-button-padrao iconSrc="icones/visualizar" iconSrcExtensao=".svg" width="20px" height="20px"
              fontSize="20px" backgroundColor="transparent" widthIcon="20px" heightIcon="20px"
              (buttonClick)="abrirModal(true, elemento)"></app-button-padrao>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef class="flex-direction-row center-center"> ID </mat-header-cell>
        <mat-cell class="flex-direction-row center-center" *matCellDef="let elemento">
          <span class="ellipse">{{ elemento.id }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="nome">
        <mat-header-cell *matHeaderCellDef class="flex-direction-row center-center"> Título </mat-header-cell>
        <mat-cell class="flex-direction-row center-center" *matCellDef="let elemento"
                  [matTooltip]="elemento.nome ?? '--'"> <span class="ellipse">{{ elemento.nome ?? '--' }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="envioVia">
        <mat-header-cell *matHeaderCellDef class="flex-direction-row align-center justify-start"> Envio via </mat-header-cell>
        <mat-cell class="flex-direction-row align-center justify-start" *matCellDef="let elemento">
          <span class="ellipse">{{ ehTemplateSms(elemento) ? 'SMS' : 'WhatsApp' }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="conta">
        <mat-header-cell *matHeaderCellDef class="flex-direction-row center-center"> Número </mat-header-cell>
        <mat-cell class="flex-direction-row center-center" *matCellDef="let elemento"
                  matTooltip="{{ elemento.conta?.nome ? elemento.conta.nome + ' - ' + (elemento.conta.numero | celularMask) : '-' }}">
          @if (elemento.conta?.nome) {
            <span class="ellipse">{{ elemento.conta.nome }} | {{ elemento.conta.numero | celularMask }}</span>
          } @else {
            <span class="ellipse">-</span>
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="setor">
        <mat-header-cell class="flex-direction-row center-center" *matHeaderCellDef> Setor </mat-header-cell>
        <mat-cell class="flex-direction-row center-center" *matCellDef="let elemento">
          <span class="ellipse" style="margin-left: 5px">{{ elemento.setor ? elemento.setor.nome : '-' }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="status">
        <mat-header-cell class="flex-direction-row center-center" *matHeaderCellDef> Status </mat-header-cell>
        <mat-cell class="flex-direction-row center-center" *matCellDef="let elemento">
          <div class="circulo" [ngStyle]="elemento.ativo ? {'background-color' : '#61B460'} : {'background-color' : '#C60000'}"></div>
          <span class="ellipse" style="margin-left: 5px">{{ elemento.ativo ? 'Ativo' : 'Inativo' }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="statusMeta">
        <mat-header-cell class="flex-direction-row center-center" *matHeaderCellDef> Status Meta </mat-header-cell>
        <mat-cell class="flex-direction-row center-center" *matCellDef="let elemento"
                  [matTooltip]="ehTemplateSms(elemento) || elemento?.enviadoMeta ? elemento.status : 'Template não enviado para meta!'">
          @if (ehTemplateSms(elemento) || elemento?.enviadoMeta) {
            <span class="ellipse">{{ elemento.status }}</span>
          } @else {
            <img src="../../../assets/icones/icone-exclamacao-vermelho.svg" width="20px" height="20px" alt="Template não enviado para a Meta"/>
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="tipo">
        <mat-header-cell class="flex-direction-row center-center" *matHeaderCellDef> Tipo</mat-header-cell>
        <mat-cell class="flex-direction-row center-center" *matCellDef="let elemento"
                  [matTooltip]="elemento.categoria ? elemento.categoria.toLowerCase() : '--'">
          <span class="ellipse">{{ elemento.categoria ? elemento.categoria.toLowerCase() : '--' }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="usuCriacao">
        <mat-header-cell class="flex-direction-row center-center" *matHeaderCellDef>
          <span class="no-break">Usu. Cria.</span>
        </mat-header-cell>
        <mat-cell class="flex-direction-row center-center" *matCellDef="let elemento"
                  [matTooltip]="elemento.usuarioCriacao?.nome ?? '--'">
          @if (elemento.usuarioCriacao?.extensaoImg) {
            <img class="img-usuario" [src]="gerarUrl(elemento.usuarioCriacao?.uuid, elemento.usuarioCriacao?.extensaoImg, 'usuario-img')" alt="Foto do usuário de criação" />
          } @else {
            <img src="./assets/icones/no-img-default.png" alt="Usuário sem foto" />
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="dataCriacao">
        <mat-header-cell class="flex-direction-row center-center" *matHeaderCellDef> Data Cria.</mat-header-cell>
        <mat-cell class="flex-direction-row center-center" *matCellDef="let elemento"
                  [matTooltip]="(elemento.dataCriacao | date:'dd/MM/yyyy - HH:mm') ?? '--'">
          <span class="ellipse">{{ (elemento.dataCriacao | date:'dd/MM/yyyy - HH:mm') || '--' }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="usuAlteracao">
        <mat-header-cell class="flex-direction-row center-center" *matHeaderCellDef>
          <span class="no-break">Usu. Alt.</span>
        </mat-header-cell>
        <mat-cell class="flex-direction-row center-center" *matCellDef="let elemento"
                  [matTooltip]="elemento.usuarioAlteracao?.nome ?? '--'">
          @if (elemento.usuarioAlteracao?.extensaoImg) {
            <img class="img-usuario" [src]="gerarUrl(elemento.usuarioAlteracao.uuid, elemento.usuarioAlteracao?.extensaoImg, 'usuario-img')" alt="Foto do usuário de alteração" />
          } @else {
            <img src="./assets/icones/no-img-default.png" alt="Usuário sem foto" />
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="dataAlteracao">
        <mat-header-cell class="flex-direction-row center-center" *matHeaderCellDef> Data Alt.</mat-header-cell>
        <mat-cell class="flex-direction-row center-center" *matCellDef="let elemento"
                  [matTooltip]="(elemento.dataAlteracao | date:'dd/MM/yyyy - HH:mm') ?? '--'">
          <span class="ellipse">{{ (elemento.dataAlteracao | date:'dd/MM/yyyy - HH:mm') || '--' }}</span>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

    <app-paginator
      [length]="length"
      [pageSize]="limit"
      [pageIndex]="page"
      [pageSizeOptions]="[10, 20, 50, 100]"
      [width]="'calc(100% - 16px) !important'"
      (pageChange)="handlePageEvent($event)">
    </app-paginator>
  }
  @else if (templatesCarregando){
    <app-tabela-skeleton [qntdLinhas]="8"></app-tabela-skeleton>
  }
  @if (templates.length === 0 && !templatesCarregando && templatesCarregados) {
    <div class="flex center-center height-100">
      <img style="height: 394px; width: 582px;" src="./assets/imagem-mulher-nao-eh-bug.png" alt="Nenhum template encontrado">
    </div>
  }

  <img src="./assets/botao-add.svg" class="botao-add cursor-pointer" alt="Adicionar template" role="button" tabindex="0" (click)="abrirModal(false)" (keydown.enter)="abrirModal(false)"/>
</div>
